import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const MaterialChevronRightIcon = () => {
  return <ChevronRightIcon htmlColor="#1A1A1A" />;
};

export default MaterialChevronRightIcon;
